import TraitPane from './TraitPane';

export default TraitPane;
export { TraitPane };
